export const BULK_STATUS = {
  WAITING: {
    name: 'WAITING',
    text: '대기중',
    icon: 'standby',
  },
  CANCELED: {
    name: 'CANCELED',
    text: '취소',
    icon: 'off',
  },
  PROCESSING: {
    name: 'PROCESSING',
    text: '작업중',
    icon: 'on',
  },
  PROCESSED: {
    name: 'PROCESSED',
    text: '완료',
    icon: 'on',
  },
  PARTIAL_FAILED: {
    name: 'PARTIAL_FAILED',
    text: '부분실패',
    icon: 'off',
  },
  TOTAL_FAILED: {
    name: 'TOTAL_FAILED',
    text: '전체실패',
    icon: 'off',
  },
}
export const DOMAIN_TYPE = {
  ALL: {
    name: 'ALL',
    text: '모든유형 사용',
  },
  BIZ_CHANNEL: {
    name: 'BIZ_CHANNEL',
    text: '비즈채널',
  },
  CAMPAIGN: {
    name: 'CAMPAIGN',
    text: '캠페인',
  },
  AD_GROUP: {
    name: 'AD_GROUP',
    text: '광고그룹',
  },
  KEYWORD: {
    name: 'KEYWORD',
    text: '키워드',
  },
  CREATIVE: {
    name: 'CREATIVE',
    text: '광고소재 관리',
  },
  CREATIVE_LINK: {
    name: 'CREATIVE_LINK',
    text: '소재연결',
  },
}
export const METHOD_TYPE = {
  CREATE: {
    name: 'CREATE',
    text: '등록',
  },
  UPDATE: {
    name: 'UPDATE',
    text: '수정',
  },
  DELETE: {
    name: 'DELETE',
    text: '삭제',
  },
}
export const TEMPLATE_TYPE = {
  CREATE_CAMPAIGN: {
    name: 'CREATE_CAMPAIGN',
    domainType: DOMAIN_TYPE.CAMPAIGN,
    methodType: METHOD_TYPE.CREATE,
  },
  UPDATE_CAMPAIGN: {
    name: 'UPDATE_CAMPAIGN',
    domainType: DOMAIN_TYPE.CAMPAIGN,
    methodType: METHOD_TYPE.UPDATE,
  },
  CREATE_ADGROUP: {
    name: 'CREATE_ADGROUP',
    domainType: DOMAIN_TYPE.AD_GROUP,
    methodType: METHOD_TYPE.CREATE,
  },
  UPDATE_ADGROUP: {
    name: 'UPDATE_ADGROUP',
    domainType: DOMAIN_TYPE.AD_GROUP,
    methodType: METHOD_TYPE.UPDATE,
  },
  CREATE_KEYWORD: {
    name: 'CREATE_KEYWORD',
    domainType: DOMAIN_TYPE.KEYWORD,
    methodType: METHOD_TYPE.CREATE,
  },
  UPDATE_KEYWORD: {
    name: 'UPDATE_KEYWORD',
    domainType: DOMAIN_TYPE.KEYWORD,
    methodType: METHOD_TYPE.UPDATE,
  },
  CREATE_CREATIVE_LINK: {
    name: 'CREATE_CREATIVE_LINK',
    domainType: DOMAIN_TYPE.CREATIVE_LINK,
    methodType: METHOD_TYPE.CREATE,
  },
  UPDATE_CREATIVE_LINK: {
    name: 'UPDATE_CREATIVE_LINK',
    domainType: DOMAIN_TYPE.CREATIVE_LINK,
    methodType: METHOD_TYPE.UPDATE,
  },
  CREATE_CREATIVE: {
    name: 'CREATE_CREATIVE',
    domainType: DOMAIN_TYPE.CREATIVE,
    methodType: METHOD_TYPE.CREATE,
  },
  DELETE: {
    name: 'DELETE',
    domainType: DOMAIN_TYPE.ALL,
    methodType: METHOD_TYPE.DELETE,
  },
}
